import { mapActions } from 'vuex'
import { eventBus } from '@/main'

export default {
    methods: {
        ...mapActions({
            FetchBursaryApplications: 'enterpriseDataApi/FetchBursaryApplications',
            FetchBursaryApplication: 'enterpriseDataApi/FetchBursaryApplication',
        }),
        LoadBursaryApplications(studentID) {
            this.loadingBursaryApplications = true;
            this.FetchBursaryApplications({ StudentID: studentID })
                .then(response => {
                    this.bursaryApplications = Object.assign([], response);
                    eventBus.$emit('bursary-applications-fetch:success');
                })
                .catch(error => eventBus.$emit('alert:error', error))
                .finally(() => this.loadingBursaryApplications = false);
        },
        LoadBursaryApplication(enrolmentID) {
            eventBus.$emit('bursary-application-fetch:started');
            this.FetchBursaryApplication({ EnrolmentID: enrolmentID })
                .then(response => {
                    this.bursaryApplication = Object.assign({}, response);
                    eventBus.$emit('bursary-application-fetch:success');
                })
                .catch(error => eventBus.$emit('alert:error', error))
                .finally(() => eventBus.$emit('bursary-application-fetch:finished'));
        },
    }
};